export enum DealerTypeEnum {
  Franchise,
  Specialist,
  Other,
  Chain,
  Independent
}
